<template>
    <div class="section">
        <div class="container-fluid">
            <div class="section">
                <div class="container ">
                    <div class="columns">
                        <div class="column is-5-desktop">
                            <h1 class="title has-text-centered">Payment Refund</h1>
                            <transition name="fade">
                                <div v-if="alertMessage" class="alert-message is-success has-text-centered">
                                    {{ alertMessage }}
                                </div>
                            </transition>
                            <form>
                                <div class="field select-client-field">
                                    <div class="control">
                                        <div class="client-name">{{ clientName }}</div>
                                        <button @click.prevent="getPayments" class="button is-primary">Get Payments</button>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <datetime
                                                input-class="input"
                                                v-model="transactionDate"
                                                :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                                type="date"
                                                value-zone="local"
                                                zone="local"
                                                placeholder="Select date"
                                        ></datetime>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <textarea v-model="description" class="textarea" placeholder="Description"></textarea>
                                    </div>
                                </div>

                                <div class="field">
                                    <div class="control text-center">
                                        <a @click.prevent="createTransaction" class="button is-primary">Submit</a>
                                        <a @click="cancel" class="button is-danger"><span>Cancel</span></a>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="column is-offset-2-desktop">
                            <h1 class="title has-text-centered">Select a payment</h1>
                            <div class="client-amount-table-container">
                                <div class="card">
                                    <div class="card-content">
                                        <div class="theme-table-container table-container center-column w-100">
                                            <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                                                <thead>
                                                <tr>
                                                    <th><span @click="setOrder('manager_id')" class="link">Payment #</span></th>
                                                    <th><span @click="setOrder('manager_id')" class="link">Amount</span></th>
                                                    <th><span @click="setOrder('manager_id')" class="link">Balance</span></th>
                                                    <th><span @click="setOrder('manager_id')" class="link">Refund Amount</span></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    <customer-payment-table-row v-for="(payment, index) in customerPayments" :payment="payment" :index="index" :action="'add'"></customer-payment-table-row>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {ModelSelect} from 'vue-search-select'
    import apiUsers from './../../api/apiUsers'
    import {Datetime} from 'vue-datetime'
    import apiProformaInvoices from "../../api/apiProformaInvoices";
    import CustomerPaymentTableRow from "../Banking/CustomerPaymentTableRow";

    export default {
        components: {
            CustomerPaymentTableRow,
            ModelSelect,
            Datetime
        },
        data() {
            return {
                customerPayments: [],
                options: [],
                transactionDate: new Date().toISOString(),
                amount: '',
                user: this.$route.params.id,
                type: 2,
                description: '',
                clientName: ''
            }
        },
        computed: {
            alertMessage: function () {
                return this.$store.getters.getTransactionStatus
            }
        },
        methods: {
            getPayments(){
                apiProformaInvoices
                    .requestPayments(this.user)
                    .then((response) => {
                        this.customerPayments = response.data;
                    })
            },
            setSelectOptions(users) {
                let list = []
                let clientId = this.$route.params.id
                users.forEach((element) => {
                    if(element.id == clientId){
                        this.clientName = element.name
                    }
                    list.push({
                        value: element.id,
                        text: element.name
                    })
                })

                this.options = list
            },
            createTransaction(){
                let payment = this.$store.getters.getCurrentRefundAmount

                let data = {
                    client_id: this.user,
                    type: this.type,
                    transaction_date: this.transactionDate,
                    description: this.description,
                    payment: payment
                }
                this.$store.dispatch('createMoneyOutTransaction', data)
                setTimeout(() => {
                    this.$store.dispatch('setActiveUserTab', 'client-balance')
                    this.$router.go(-1)
                }, 1000)
            },
            cancel(){
                this.$store.dispatch('setActiveUserTab', 'client-balance')
                this.$router.go(-1)
            }
        },
        created() {
            this.$store.commit('setTransactionStatus', '')
            apiUsers
                .requestAllUsers()
                .then((response) => {
                    this.setSelectOptions(response.data)
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
</script>

<style scoped>

    .field.select-client-field .control {
        display: flex;
    }

    .field.select-client-field .control button.button.is-primary {
        margin-left: 10px;
        align-self: center;
    }
    .alert-message {
        margin-bottom: 10px;
    }
    table.table.client-amount-table {
        width: 100%;
    }
    .error-alert {
        background-color: #ffecec;
        color: #b94a48;
        padding: 5px 10px;
        border: 1px solid #ffdde2;
        border-radius: 5px;
        margin-bottom: 10px;
    }
    .client-name {
        background: #fff;
        box-shadow: inset 0 1px 2px rgba(10,10,10,.1);
        padding-bottom: calc(.375em - 1px);
        padding-left: calc(.625em - 1px);
        padding-right: calc(.625em - 1px);
        padding-top: calc(.375em - 1px);
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Balance-Statement/CreateClientRefundTransaction.vue